// eslint-disable-next-line import/prefer-default-export
export const data = {
    /// /////////////////////////////////////////////////////////
    /// /////////////// Header //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Main_Nav_Welcome: "欢迎，",
    Main_Nav_HelpfulLinks: "常用链接",
    Main_Nav_LogOut: "登出",
    Main_Nav_HelpfulLinks_LI_s1: "联系我学生的护士",
    Main_Nav_HelpfulLinks_LI_s2: "校历",
    Main_Nav_HelpfulLinks_LI_s3: "家长资源",
    Main_Nav_HelpfulLinks_LI_s4: "校车路线",
    Main_Nav_HelpfulLinks_LI_s5: "在线支付",
    Main_Nav_HelpfulLinks_LI_s6: "午餐菜单",
    Main_Nav_Exit: "退出",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Global //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Global_BackToDashboard: "返回仪表板",
    Global_Dashboard: "仪表板",
    Global_Faq: "常见问题",
    Global_Close: "关闭",
    Global_Completed: "已完成",
    Global_Currently_Unavailable: "当前不可用",
    Global_InProgress: "进行中",
    Global_GoTo: "前往",
    Global_Loading: "正在收集您学生的信息，请稍候...",
    Global_MoreInfo: "更多信息",
    Global_NotStarted: "未开始",
    Global_Open: "打开",
    Global_Status: "状态",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Breadcrumb //////////////////////////////
    /// /////////////////////////////////////////////////////////
    Breadcrumb: "DCSD 监护人仪表板",
    Breadcrumb_Back: "DCSD Engaged 家长门户",
    Breadcrumb_EPR: "DCSD 已归档成绩单",
    Breadcrumb_Translations: "翻译仅供参考（实验性）",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Report Card /////////////////////////////
    /// /////////////////////////////////////////////////////////
    EPR_Available: "您学生的成绩单将于",
    EPR_Failure1: "抱歉，我们无法检索该学生的成绩单 PDF",
    EPR_Failure2: "联系学区寻求支持时，请提供以下信息：",
    EPR_No_Data: "未找到该学生的历史成绩单。",
    EPR_Not_Found: "您学生的成绩单尚未准备好。请联系您学生的学校以获取更多信息。",
    EPR_Success: "已成功检索该学生的成绩单 PDF。",
    EPR_Title: "已归档成绩单资源",
    EPR_View_Archive: "已归档成绩单",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Most Recent /////////////////////////
    /// /////////////////////////////////////////////////////////
    Most_Recent_Title: "最新成绩单",
    Most_Recent_Pdf_Download: "下载 PDF",
    Most_Recent_Success: "已成功检索该学生的成绩单 PDF。",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Student Info ////////////////////////
    /// /////////////////////////////////////////////////////////
    Student_Info_Address: "地址",
    Student_Info_Grade: "年级",
    Student_Info_School: "学校",
    Student_Info_School_Year: "学年",
    Student_Info_Teacher: "教师",
    Student_Info_Not_Ready: (
        <>
            成绩单 PDF 尚未就绪。
            <br />
            请稍后再查看。
        </>
    ),
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Student Select //////////////////////
    /// /////////////////////////////////////////////////////////
    Student_Select_Instructions: "选择一名学生以查看其成绩单",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// About ///////////////////////////////
    /// /////////////////////////////////////////////////////////
    About_Epr: "关于成绩单",
    About_Based: "成绩单基于道格拉斯县学区的保证和可行课程 (GVC)。所有项目按以下标准评分：",
    About_Exceeds: "我超越课程标准的期望，并且能够独立、准确地完成它们.",
    About_Meets: "我达到课程标准的期望，并且能够独立完成它们，没有重大错误。",
    About_Approaching: "我对课程标准有部分理解，并且/或者需要支持才能完成它们。",
    About_Does_Not_Meet: "我未达到课程标准的期望，并且/或者需要大量支持。",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Semester ////////////////////////////
    /// /////////////////////////////////////////////////////////
    Semester_Semester: "学期",
    Semester_Selected: "选定学期",
    Semester_Overall: "总体评语",
    Semester_Comment_All: "给所有学生的评语",
    Semester_Comment_Student: "学期评语",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Resources ///////////////////////////
    /// /////////////////////////////////////////////////////////
    Resources_Associated: "相关资源",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// SLE /////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Sle_Title: "学校级期望",
    Sle_Comment: "学校级期望评语",
    Sle_Comment_To_All: "给全体学生的学校期望评语",
    Sle_No_Ratings: "未输入评分",
    Sle_No_Comment: "未输入评语",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Subject /////////////////////////////
    /// /////////////////////////////////////////////////////////
    Subject_Selected: "选定科目",
    Subject_Comments: "评语",
    Subject_Comment: "评语",
    Subject_To_All: "给所有学生的评语，针对",
    Subject_Ratings: "评分",
    Subject_Accelerated: "高级",
    Subject_Evidence_Outcome: "证据结果",
    Subject_Evidence_Outcome_Child: "子项证据结果",
    Subject_Standard: "标准",
    Subject_Student_Comment: "学生评语",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Archived ////////////////////////////
    /// /////////////////////////////////////////////////////////
    Archived_Description: "查看或下载您学生的已归档成绩单",
    Archived_Resources: "已归档成绩单资源",
    Archived_Fail_1: "抱歉，我们无法检索该学生此学年的成绩单 PDF：",
    Archived_Fail_2: (
        <>
            联系学区寻求支持时，请提供以下信息：
            <br />
        </>
    ),
    Archived_Success: "已成功检索并下载该学生此学年的成绩单 PDF：",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// 404 /////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Page_Not_Found: "未找到页面",
    Page_Not_Found_Message: "基于您输入的 URL 或您当前的职位或您当前的位置，此应用程序不可用。"
};
